import React, { useState, useEffect, useRef } from "react";
import api from '../../../../../../../api';
import {
    Form,
    Button,
    Checkbox,
    Table,
    Input,
    TextArea,
    Dropdown,
    Header,
    Modal,
    Icon,
    Dimmer,
    Loader,
    Message
} from "semantic-ui-react";
import styles from "./DataConnect.module.css";
import "./DataConnectPage.css";
import AutoGenerated from "./AutoGenerated";
import UserGuideModal from "../UserGuideModal";
import { useVapiVariables } from "../../../../../../../hooks/useVapiVariables";

const DataLayerModal = ({ open, onClose, preformData, updateConnectiontools, setshowErrortype, connections, workspace_id }) => {
    const [formData, setFormData] = useState(preformData);
    const [loading, setLoading] = useState(true);
    const [editId, seteditId] = useState(null);
    const [subitStatus, setSubmitStatus] = useState(false);
    const [showErrortypeModal, setshowErrortypeModal] = useState({ type: "", title: "", message: "" });
    const [showErrortypeTimezoneModal, setshowErrortypeTimezoneModal] = useState({ type: "", title: "", message: "" });
    const [newProperty, setNewProperty] = useState({
        name: "",
        description: "",
        type: "string",
    });
    const [timezone, settimezone] = useState(null);
    const [selectedtimezone, setselectedtimezone] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false); // New state to track submission status
    const modalTopRef = useRef(null);
    const toolcontextRef = useRef(null);
 
    const [autoModalOpen, setAutoModalOpen] = useState(false);
    const [dbResult, setDbResult] = useState(null);
    const [toolcontextHighlight, setToolcontextHighlight] = useState(false);
    const { variables: availableVariables, loading: variablesLoading } = useVapiVariables('context');
    const [userGuideOpen, setuserGuideOpen] = useState(false);
    const stripHtmlTags = (str) => {
        if (!str) return str;
        return str.replace(/<[^>]*>/g, ''); // Removes all HTML tags
    };
    
    const openAutoModal = (db_id) => {
		// setSelecteTool(database.id);
		setAutoModalOpen(true);
      
        api.DatalayerandTooling.getDbReuslt(db_id).then((res) => {
            setDbResult(res.data);
        }).catch((error) => {
            setDbResult(null);
        });
	};

    const closeAutoModal = () => {
		setAutoModalOpen(false);
		setDbResult(null); // Clear the database result when modal closes
	};

    const handleApprovedContext = (approvedContext) => {
        console.log('Approved context received:', approvedContext);
        console.log('Previous toolcontext:', formData.toolcontext);
        
        // Update the toolcontext field with approved context
        setFormData((prev) => ({
            ...prev,
            toolcontext: approvedContext
        }));
        
        console.log('Toolcontext updated successfully');
        
        // Highlight the toolcontext field
        setToolcontextHighlight(true);
        
        // Remove highlight after 3 seconds
        setTimeout(() => {
            setToolcontextHighlight(false);
        }, 3000);
        
        // Close the auto modal
        setAutoModalOpen(false);
    };

    useEffect(() => {
            api.botbuilder.gettimezoneHourConfigration().then( ( res ) => {
                settimezone(res.timezone?res.timezone:[])
            });
    }, []);

    useEffect(() => {
        if (showErrortypeModal.message) {
            setTimeout(() => {
                setshowErrortypeModal({ type: "", title: "", message: "" });
            }, 10000);
            if (modalTopRef.current) {
                modalTopRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [showErrortypeModal]);

    useEffect(() => {
        if (showErrortypeTimezoneModal.message) {
            setTimeout(() => {
                setshowErrortypeTimezoneModal({ type: "", title: "", message: "" });
            }, 5000);
            if (modalTopRef.current) {
                modalTopRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [showErrortypeTimezoneModal]);

    const handleInputChange = (e, data = null) => {
        const { name, value, type, checked } = e.target;
        console.log(name,value,type,checked,"handleInputChange");
        if(name == 'connectionName'){
            //check this value should not contains any special charecter expect _
            if(!/^[a-zA-Z0-9_]+$/.test(value) && value.trim() !== ''){
                setshowErrortypeModal({ type: "negative", title: "Failed!", message: "Connection Name should not contains any special charecter expect _" });
                return;
            }
        }
        if (name !== undefined) {
            setFormData((prev) => ({
                ...prev,
                [name]: stripHtmlTags(value),
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [data.name]: data.checked,
            }));
        }
    };
    const handleInputVariable = (val, data = null) => {
        const { name, value, type } = {"name":"toolcontext","value":val,"type":"textarea"}
        if(name == 'connectionName'){
            //check this value should not contains any special charecter expect _
            if(!/^[a-zA-Z0-9_]+$/.test(value) && value.trim() !== ''){
                setshowErrortypeModal({ type: "negative", title: "Failed!", message: "Connection Name should not contains any special charecter expect _" });
                return;
            }
        }
        if (name !== undefined) {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [data.name]: data.checked,
            }));
        }
    };

    const handlePropertyChange = (key, value) => {
        setNewProperty((prev) => ({
            ...prev,
            [key]: stripHtmlTags(value),
        }));
    };

    const renderTimezone = ( selectedhour ) => {
        let timezoneArray = Object.entries(timezone);
        let stateTemp = {...selectedhour}
        let timezons =  timezoneArray.map(( timezone ) => {
            return {
                key: timezone[1],
                text: timezone[0] + timezone[1],
                value: timezone[1]
            }
        });
        return {
            timezone : timezons,
            stateTemp:stateTemp
        }
    }
    
    const handleAddProperty = () => {
        if (editId !== null) {
            if (newProperty.name != undefined && newProperty.description != undefined && newProperty.name.trim()) {
                if (newProperty.name.trim() !== '' && newProperty.description.trim() !== "") {
                    formData.properties[editId] = newProperty;
                    setFormData((prev) => ({
                        ...prev,
                        properties: [...prev.properties],
                    }));
                    setNewProperty({ name: "", description: "", type: "string" });
                    seteditId(null);
                } else {
                    setshowErrortypeModal({ type: "negative", title: "Failed!", message: "Name or Description should not be blank." });
                }
            } else {
                setshowErrortypeModal({ type: "negative", title: "Failed!", message: "Name or Description should not be blank." });
            }
            return;
        } else {
            seteditId(null);
            if (newProperty.name != undefined && newProperty.description != undefined && newProperty.name.trim()) {
                if (newProperty.name.trim() !== '' && newProperty.description.trim() !== "") {
                    setFormData((prev) => ({
                        ...prev,
                        properties: [...prev.properties, newProperty],
                    }));
                    setNewProperty({ name: "", description: "", type: "string" });
                } else {
                    setshowErrortypeModal({ type: "negative", title: "Failed!", message: "Name and description should not be empty." });
                }
            } else {
                setshowErrortypeModal({ type: "negative", title: "Failed!", message: "Name or Description should not be blank." });
            }
        }
    };

    const handleDeleteProperty = (id) => {
        formData.properties.splice(id, 1);
    };

    const handleSubmit = async () => {
        // Prevent multiple submissions
        if (isSubmitting) return;
        
        setIsSubmitting(true); // Set submitting state to true
        
        // Validate required fields
        const { connectionName, description, properties, toolcontext } = formData;
        if (!connectionName.trim() && connectionName.trim() == "") {
            setshowErrortypeModal({ type: "negative", title: "Failed!", message: "Name and description should not be empty." });
            setIsSubmitting(false); // Reset submitting state on validation failure
            return;
        }
        
        if (!description.trim()) {
            setshowErrortypeModal({ type: "negative", title: "Failed!", message: "Description is required!" });
            setIsSubmitting(false);
            return;
        }
        if (properties.length === 0) {
            setshowErrortypeModal({ type: "negative", title: "Failed!", message: "Properties are required!" });
            setIsSubmitting(false);
            return;
        }
        if(!selectedtimezone){
            setshowErrortypeTimezoneModal({ type: "negative", title: "Failed!", message: "Please select timezone." });
            setIsSubmitting(false);
            return;
        }
        if(!toolcontext){
            setshowErrortypeTimezoneModal({ type: "negative", title: "Failed!", message: "Please enter relevent context for this tool." });
            setIsSubmitting(false);
            return;
        }
        
        try {
            setLoading(true);
            setSubmitStatus(true);
            
            if (formData.id == null) {
                let payload = { ...formData, workspace_id: atob(workspace_id), selectedtimezone: selectedtimezone }
                api.DatalayerandTooling.saveNewturboTool(payload).then((res) => {
                    console.log(res,"saveNewturboTool");
                    if (res.status == true) {
                        updateConnectiontools(workspace_id);
                        setshowErrortype({ type: "positive", title: "Success!", message: "New tool has been added successfully." });
                        setLoading(false);
                        setSubmitStatus(true);
                    } else {
                        setshowErrortype({ type: "negative", title: "Failed!", message: "Something went wrong." });
                        setLoading(false);
                        setSubmitStatus(true);
                    }
                    setIsSubmitting(false); // Reset submitting state after API call completes
                    onClose();
                }).catch(error => {
                    setIsSubmitting(false);
                    setshowErrortype({ type: "negative", title: "Failed!", message: error.message });
                    onClose();
                });
            } else {
                let payload = { ...formData, workspace_id: workspace_id, selectedtimezone: selectedtimezone }
                api.DatalayerandTooling.editNewturboTool(payload).then((res) => {
                    if(res.token){
                        setshowErrortype({ type: "negative", title: "Failed!", message: "Something went wrong. Please refresh this page and try again" });
                        setLoading(false);
                        setSubmitStatus(true);
                        setIsSubmitting(false);
                        onClose();
                        return;
                    }
                    if (res.status != 200) {
                        updateConnectiontools(workspace_id);
                        setshowErrortype({ type: "positive", title: "Success!", message: "Tool has been updated successfully." });
                        setLoading(false);
                        setSubmitStatus(true);
                    } else {
                        setshowErrortype({ type: "negative", title: "Failed!", message: "Something went wrong." });
                        setLoading(false);
                        setSubmitStatus(true);
                    }
                    setIsSubmitting(false);
                    onClose();
                }).catch(error => {
                    setIsSubmitting(false);
                    setshowErrortype({ type: "negative", title: "Failed!", message: error.message });
                    onClose();
                });
            }
        } catch (error) {
            setshowErrortype({ type: "negative", title: "Failed!", message: error.message });
            setLoading(false);
            setSubmitStatus(true);
            setIsSubmitting(false);
            onClose();
        }
    };
    const setTimezoneAndalert = ( value ) => {
        // Here we will replace the old timezone in formData.toolcontext with the newly selected timezone.
        // First, we will find the old timezone parts using regex and replace them with the new value.
        // If the old part is not found, we will add the new timezone at the end of the context.

        // Prepare new timezone string
        let newTimezoneStr = '';
        if (timezone && Array.isArray(timezone)) {
            // Find label based on selectedtimezone
            const found = timezone.find(tz => tz.value === value);
            if (found) {
                newTimezoneStr = `(${found.value}) ${found.text}`;
            } else {
                newTimezoneStr = value;
            }
        } else {
            newTimezoneStr = value;
        }

        // Old context
        let oldContext = formData.toolcontext || '';
        // Find old timezone parts using regex
        // Example: "Consider current time according to timezone (UTC-10:00) Honolul"
        // or "Consider the current time of timezone (UTC+5:30) Kolkata"
        // Regex updated to support both patterns
        const regex = /(Consider (?:current time according to timezone|the current time of timezone)\s*)\([^)]+\)\s*[^.\n]*/i;

        

        let newContext = '';
        if (regex.test(oldContext)) {
            // If pattern is found, replace it with new timezone
            newContext = oldContext.replace(regex, `$1${newTimezoneStr}`);
        } else {
            // If not found, add it to the end of context
            if (oldContext.trim().length > 0) {
                newContext = oldContext.trim() + `\nConsider current time according to timezone ${newTimezoneStr}`;
            } else {
                newContext = `Consider current time according to timezone ${newTimezoneStr}`;
            }
        }

        setFormData(prev => ({
            ...prev,
            toolcontext: newContext
        }));
        setselectedtimezone(value);
        setTimezone(value);
    }

    const openUserGuideModal = () => {
        setuserGuideOpen(true);
    }
    const closeUserGuide = () => {
        setuserGuideOpen(false);
    }

    const messageAlert = () => {
        if (showErrortypeModal.title != "") {
            return (
                showErrortypeModal.type == 'negative' ?
                    <Message negative>
                        <Message.Header>{showErrortypeModal.title}</Message.Header>
                        <p>{showErrortypeModal.message}</p>
                    </Message> :
                    <Message positive>
                        <Message.Header>{showErrortypeModal.title}</Message.Header>
                        <p>{showErrortypeModal.message}</p>
                    </Message>
            )
        } else {
            return <></>
        }
    }

    const messageAlertTimezone = () => {
        if (showErrortypeTimezoneModal.title != "") {
            return (
                showErrortypeTimezoneModal.type == 'negative' ?
                    <Message negative>
                        <Message.Header>{showErrortypeTimezoneModal.title}</Message.Header>
                        <p>{showErrortypeTimezoneModal.message}</p>
                    </Message> :
                    <Message positive>
                        <Message.Header>{showErrortypeTimezoneModal.title}</Message.Header>
                        <p>{showErrortypeTimezoneModal.message}</p>
                    </Message>
            )
        } else {
            return <></>
        }
    }

    const handleEditProperty = (id) => {
        let property = formData.properties[id];
        setNewProperty(property);
        seteditId(id);
    }

    const setSelectedProperties = (value) => {
        setFormData((prev) => ({
            ...prev,
            required: value,
        }));
    }

    const renderSelectedProperties = () => {
        const propertyOptions = formData.properties.map(property => ({
            key: property.name,
            text: property.name,
            value: property.name
        }));

        return (
            <>
                <Form.Field className={styles.mrtop}>
                    <label>Select Properties</label>
                    <Dropdown
                        placeholder="Select properties"
                        fluid
                        multiple
                        selection
                        options={propertyOptions}
                        value={formData.required}
                        onChange={(e, { value }) => setSelectedProperties(value)}
                    />
                </Form.Field>
            </>
        );
    }

    const setTimezone = (timezone) => {
        console.log(timezone,"setTimezone");
        setselectedtimezone(timezone);
    }

    useEffect(() => {
       
        if (formData?.selectedtimezone && (selectedtimezone==null || selectedtimezone=="")) {
            setselectedtimezone(formData.selectedtimezone);
        }
    }, [formData]);

    const svdb = (value) => {
        console.log(value,"svdb");
        setFormData((prev) => ({ ...prev, databasefortool: value }))
    }

    const renderSelectDatabase = () => {
        const databaseconections = connections.map((db) => {
            return {
                key: db.id,
                text: db.name,
                value: db.id,
            };
        });
        return (
            <Form.Field className={styles.mrtop}>
                <label className={styles.mrtop}>Select Database</label>
                <Dropdown
                    placeholder="Select database"
                    fluid
                    selection
                    options={databaseconections}
                    value={formData.databasefortool}
                    onChange={(e, { value }) => svdb(value)}
                />
            </Form.Field>
        );
    }

    return (
        <>
            <div ref={modalTopRef}></div>
            <Dimmer
                className={styles.newLoader}
                active={loading}
                inverted
            >
            </Dimmer>
            <div className="datlayermodal">
                <Modal open={open} className={styles.customModal}>
                    <Loader>Loading...</Loader>
                    <Modal.Header className={styles.modalHeader}>
                        <span>Turbo Voice Tools</span>
                        <button type="button" className="close linear-gradient" onClick={onClose}
                            data-dismiss="modal" aria-label="Close"
                            style={{
                                fontSize: '16px',
                                padding: "2px",
                                width: "30px",
                                height: "30px"
                            }}>X</button>
                    </Modal.Header>
                    <Modal.Content>
                        <Form id="dataLayerForm" id="datalayermodalpopup">
                            <Form.Field className={styles.mrtop}>
                                <label>Connection Name</label>
                                <span className="small" style={{ color: 'orange' }}>Note: Connection name cannot contain whitespace or special characters except '_'</span>
                                {messageAlert()}
                                
                                <Input
                                    name="connectionName"
                                    value={formData.connectionName}
                                    onChange={handleInputChange}
                                    style={{ backgroundColor: "#f9f9f9" }}
                                    className="inputBorderFeild"
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>What does this connection do?</label>
                                <TextArea
                                    name="description"
                                    placeholder="The purpose of the tool is to look up info about an existing customer"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    style={{ minHeight: 80 }}
                                />
                            </Form.Field>
                            <Form.Field className={styles.mrtop}>
                                <label>Request Start</label>
                                
                                <Input
                                    name="request_start"
                                    value={formData.request_start}
                                    onChange={handleInputChange}
                                    style={{ backgroundColor: "#f9f9f9" }}
                                    className="inputBorderFeild"
                                />
                            </Form.Field>
                            <Form.Field className={styles.mrtop}>
                                <label>Request Complete</label>
                                
                                <Input
                                    name="request_complete"
                                    value={formData.request_complete}
                                    onChange={handleInputChange}
                                    style={{ backgroundColor: "#f9f9f9" }}
                                    className="inputBorderFeild"
                                />
                            </Form.Field>
                            <Form.Field className={styles.mrtop}>
                                <label>Request Failed</label>
                                
                                <Input
                                    name="request_failed"
                                    value={formData.request_failed}
                                    onChange={handleInputChange}
                                    style={{ backgroundColor: "#f9f9f9" }}
                                    className="inputBorderFeild"
                                />
                            </Form.Field>
                            <Form.Field className={styles.mrtop}>
                                <label>Request Response Delayed</label>
                                
                                <Input
                                    name="request_response_delayed"
                                    value={formData.request_response_delayed}
                                    onChange={handleInputChange}
                                    style={{ backgroundColor: "#f9f9f9" }}
                                    className="inputBorderFeild"
                                />
                            </Form.Field>
                            <Form.Field>
                                <Checkbox
                                    label="Async"
                                    name="isAsync"
                                    checked={formData.isAsync}
                                    onChange={(e, data) => handleInputChange(e, data)}
                                />
                                <p>This setting defines whether the assistant will move forward or wait for your server to respond. Enable this if you just want to trigger something on your server.</p>
                            </Form.Field>
                        </Form>

                        <Header as="h4">Properties</Header>
                        <p>All properties must be trigger your connection.</p>
                        <Form.Field style={{ width: '100%' }}>
                            <label>Property Name </label>
                            <Input
                                className={`$"inputBorderFeild"`}
                                placeholder="Enter property name"
                                value={newProperty.name ?? ""}
                                onChange={(e) => handlePropertyChange("name", e.target.value)}
                            />
                        </Form.Field>

                        <Form.Group widths="equal">
                            <Form.Field>
                                <label>Describe the property</label>
                                <TextArea
                                    placeholder="Enter description"
                                    value={newProperty.description}
                                    onChange={(e) => handlePropertyChange("description", e.target.value)}
                                    style={{ minHeight: 80 }}
                                />
                            </Form.Field>

                            <Form.Field>
                                <label>Property Type</label>
                                <Dropdown
                                    placeholder="Select property type"
                                    fluid
                                    selection
                                    options={[
                                        { key: "string", text: "String", value: "string" },
                                        { key: "number", text: "Number", value: "number" },
                                        { key: "boolean", text: "Boolean", value: "boolean" },
                                        { key: "object", text: "Object", value: "object" },
                                        { key: "array", text: "Array", value: "array" },
                                    ]}
                                    value={newProperty.type}
                                    onChange={(e, { value }) => handlePropertyChange("type", value)}
                                />
                            </Form.Field>

                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                {
                                    editId == null ?
                                        <button
                                            type="button"
                                            className="btn btn-icon linear-gradient"
                                            onClick={handleAddProperty}
                                        >
                                            Add
                                        </button> :
                                        <button
                                            type="button"
                                            className="btn btn-icon delete-btn"
                                            onClick={handleAddProperty}
                                        >
                                            Edit
                                        </button>
                                }
                            </div>
                        </Form.Group>
                        <Header as="h4">Properties for this connection:</Header>
                        <Table celled compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Property Name</Table.HeaderCell>
                                    <Table.HeaderCell>Actions</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {formData.properties.map((prop, index) => (
                                    <Table.Row key={index}>
                                        <Table.Cell>{prop.name}</Table.Cell>
                                        <Table.Cell>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-icon"
                                                    onClick={() => handleEditProperty(index)}
                                                >
                                                    <i className="la la-edit blue" title="Edit"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-icon"
                                                    onClick={() => handleDeleteProperty(index)}
                                                >
                                                    <i className="la la-trash red" title="Delete"></i>
                                                </button>
                                            </div>
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>

                        {renderSelectedProperties()}
                        {renderSelectDatabase()}
                        
                        <Form>
                            <Form.Field className={styles.mrtop} >
                            {messageAlertTimezone()}
                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'10px', marginTop:'10px' }}>
                                    <label>Relevant context for this tool</label>
                                    <button 
                                        className={`btn ${formData.databasefortool ? 'linear-gradient yr-submitbtn' : 'yr-submitbtn-disabled'}`}
                                        onClick={() => formData.databasefortool ? openAutoModal(formData.databasefortool) : null}
                                        disabled={!formData.databasefortool}
                                        style={{
                                            opacity: formData.databasefortool ? 1 : 0.5,
                                            cursor: formData.databasefortool ? 'pointer' : 'not-allowed'
                                        }}
                                    > 
                                                                                 {formData.databasefortool ? 'Auto Generate' : ''}
                                    </button>
                                </div>
                                
                                <TextArea
                                        ref={toolcontextRef}
                                        name="toolcontext"
                                        placeholder="The purpose of the tool is to look up info about an existing customer"
                                        value={formData.toolcontext}
                                        onChange={handleInputChange}
                                        style={{ minHeight: 80 }}
                                        className={toolcontextHighlight ? 'toolcontext-highlight' : ''}
                                        id="toolcontextBox"
                                    />
                            </Form.Field>
                            {/* insert variable for toolcontext */}
                            <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <div className="box-titlebox-title" style={{ fontWeight: "bold" }}>You can use these variables:</div>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                                    <select
                                        className="form-control"
                                        style={{ width: "250px", height: '45px' }}
                                        defaultValue=""
                                        onChange={(e) => {
                                            if (e.target.value) {
                                              const variable = e.target.value;
                                              if (document.getElementById('toolcontextBox')) {
                                                const textarea = document.getElementById('toolcontextBox');
                                                const textareaRef = toolcontextRef.current;
                                                const scrollTop = textarea.scrollTop;
                                                console.log(textarea,"textarea",textarea.selectionStart,textarea.selectionEnd);
                                                const start = textarea.selectionStart || 0;
                                                const end = textarea.selectionEnd || 0;
                                                const text = textarea.value || "";
                                                const before = text.substring(0, start);
                                                const after = text.substring(end);
                                                const newText = before + ` {{${variable}}} ` + after;
                                  
                                                console.log("newText:", newText); // Debug
                                                handleInputVariable(newText);
                                               
                                                setTimeout(() => {
                                                  textarea.focus();
                                                   textarea.selectionEnd = start + variable.length + 6;
                                                   //set cursor to the end of the variable string
                                                   textarea.selectionStart = start + variable.length + 6;
                                                   textarea.selectionEnd = start + variable.length + 6;
                                                   textarea.focus();
                                                   textarea.scrollTop = scrollTop;
                                                }, 0);
                                              }
                                              e.target.value = "";
                                            }
                                          }}
                                    >
                                        <option value="" disabled>Select Variable To Insert</option>
                                        {availableVariables.map((variable, index) => (
                                            <option key={index} value={variable.key || variable.value}>
                                                {variable.label || variable.name || variable.text}
                                            </option>
                                        ))}
                                    </select>
                                    <button
                type="button"
                className="btn linear-gradient yr-submitbtn"
                style={{ cursor: "pointer", fontSize: "16px", padding: "6px 16px" }}
                onClick={openUserGuideModal}
                id="userguidemodalbtn"
                title="Variables Guide"
            >
                Variables Guide
            </button>
                                 
                                </div>
                                <div style={{ fontSize: "12px", color: "#888", marginTop: "10px" }}>
                                    <p>
                                        <strong style={{ fontWeight: '600' }} className="text-info">Note:</strong> Insert these variables in your tool context, and they will be automatically replaced with real-time values.
                                    </p>
                                </div>
                            </div>
                            {/* end of insert variable for toolcontext */}
                            
                            <Form.Field className={styles.mrtop}>
                                <label>Select timezone when call take place </label>
                                
                                {selectedtimezone ?? ""}
                                {timezone &&<Dropdown
                                    placeholder='Select Timezone'
                                    fluid
                                    search
                                    selection
                                    name="timezone"
                                    options={renderTimezone().timezone}
                                    className='form-group mb-2 pl-2'
                                    value={selectedtimezone ??""}
                                    onChange={(e, { value }) => setTimezoneAndalert(value)}
                                />}
                            </Form.Field>
                        </Form>
                    </Modal.Content>
                    {!subitStatus && 
                        <Modal.Actions>
                            <button 
                                onClick={handleSubmit} 
                                className="btn linear-gradient yr-submitbtn"
                                disabled={isSubmitting} // Disable button when submitting
                            >
                                {isSubmitting ? 'Saving...' : 'Save'}
                            </button>
                        </Modal.Actions>
                    }
                </Modal>
                <AutoGenerated
                    open={autoModalOpen}
                    onClose={closeAutoModal}
                    onConfirm={dbResult}
                    onApprove={handleApprovedContext}
                    selectedtimezone = {selectedtimezone}
                    toolcontext = {formData.toolcontext}
                />
                <UserGuideModal open={userGuideOpen} onClose={closeUserGuide}  showModal={userGuideOpen}/>
            </div>

        </>
    );
};


export default DataLayerModal;